import { Autocomplete } from "common/component/Autocomplete";
import { highlight } from "common/component/Autocomplete";
import * as stylesheet from "common/component/Autocomplete/Autocomplete.less";
import { Value } from "common/component/Autocomplete/types";
import { fromStyleLocals } from "common/css";
import { ClientDto, SearchCriteria } from "common/types/account";
import { differenceBy, get, map, noop } from "lodash";
const css = fromStyleLocals(stylesheet.locals);
import { h } from "preact";

export class AccountAutocomplete extends Autocomplete<
  ClientDto,
  SearchCriteria
> {
  protected getData(
    onSelect: (item: ClientDto) => void,
    exclude: ClientDto[],
    items: ClientDto[],
    criteria?: SearchCriteria
  ): Value[] {
    if (criteria === undefined) {
      return [];
    }

    const head: Value = {
      onclick: noop,
      properties: ["Account name", "Level", "Country", "Ccial id", "Legal id"],
      style: css("list-group-item", "header"),
    };

    const tail: Value[] = map(differenceBy(items, exclude, "id"), item => ({
      onclick: () => onSelect(item),
      properties: [
        highlight(criteria.name, get(item, "name", "")),
        get(item, "clientIds.internalId.level", ""),
        get(item, "country.iso3", ""),
        highlight(
          criteria.clientComm,
          get(item, "bdrId.bdrCommercialId.id", "")
        ),
        highlight(criteria.clientLegal, get(item, "bdrId.bdrLegalId.id", "")),
      ],
      style: css("list-group-item"),
    }));

    return [head].concat(tail);
  }

  protected renderRow({ style, onclick, properties }: Value) {
    const styles = [
      "",
      "",
      "hidden-xs", // COUNTRY
      "hidden-md hidden-sm hidden-xs", // CCIAL ID
      "hidden-sm hidden-xs", // LEGAL ID
    ];
    return (
      <div class={style} onClick={() => onclick()}>
        {properties.map((p, i) => (
          // tslint:disable-next-line:trailing-comma
          <span
            class={css("col", styles[i])}
            dangerouslySetInnerHTML={{ __html: p }}
          />
        ))}
      </div>
    );
  }
}
